"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscribeUnsubscribeNewsletterModes = exports.LandingPageLoggerDataModes = exports.PublicResourcesRequestModes = void 0;
var PublicResourcesRequestModes;
(function (PublicResourcesRequestModes) {
    PublicResourcesRequestModes["QR_LOGOS"] = "qr-logos";
})(PublicResourcesRequestModes = exports.PublicResourcesRequestModes || (exports.PublicResourcesRequestModes = {}));
var LandingPageLoggerDataModes;
(function (LandingPageLoggerDataModes) {
    LandingPageLoggerDataModes["QR_GENERATED"] = "qr-generated";
    LandingPageLoggerDataModes["CART_INITIALIZED"] = "cart-initialized";
})(LandingPageLoggerDataModes = exports.LandingPageLoggerDataModes || (exports.LandingPageLoggerDataModes = {}));
var SubscribeUnsubscribeNewsletterModes;
(function (SubscribeUnsubscribeNewsletterModes) {
    SubscribeUnsubscribeNewsletterModes["DO_NOT_DISTURB"] = "do_not_disturb";
    SubscribeUnsubscribeNewsletterModes["TELL_ME_RELEVANT_UPDATES"] = "tell_me_relevant_updates";
    SubscribeUnsubscribeNewsletterModes["TELL_ME_PROMOTIONAL_UPDATES"] = "tell_me_promotional_updates";
})(SubscribeUnsubscribeNewsletterModes = exports.SubscribeUnsubscribeNewsletterModes || (exports.SubscribeUnsubscribeNewsletterModes = {}));
